<template>
  <div class="main_train">
    <div class="common_title">
      <span class="title pointer">教研培训</span>
      <span class="more pointer" @click="toList">更多</span>
    </div>
    <div class="main_train_content">
      <z-list :list="list" @toDetail="toDetail"></z-list>
    </div>
  </div>
</template>

<script>
import list from '@/components/list/list'
export default {
  name: 'mainTrain',
  components: {
    'z-list': list
  },
  props: ['jypx'],
  data () {
    return {}
  },
  created () {
  },
  mounted () {
  },
  computed: {
    list () {
      return this.jypx
    }
  },
  methods: {
    toList () {
      this.$router.push({
        path: '/train'
      })
    },
    toDetail (itemId) {
      this.$router.push({
        path: '/train/detail',
        query: {
          itemId: itemId
        }
      })
    }
  },
  watch: {}
}
</script>

<style scoped>
  .main_train { width: 490px; height: 460px; padding: 0 10px; border-radius: 2px; border: 1px solid #DCDFE6; float: right; }
  .main_train_content { padding: 20px 0; height: 408px; overflow: auto; }
</style>



// WEBPACK FOOTER //
// src/components/main/train.vue